// src/authFetch.js
import API_BASE_URL from "./api";

// Соединяем base + относительный путь, аккуратно убирая лишние "/"
function joinBase(base, path) {
  const b = String(base).replace(/\/+$/, "");
  const p = String(path || "").replace(/^\/+/, "");
  return `${b}/${p}`;
}

const API_ORIGIN = new URL(API_BASE_URL).origin;

// Абсолютный URL?
function isAbsolute(u) {
  try { new URL(u); return true; } catch { return false; }
}

// Строим полный URL:
// - если передали относительный путь — приклеиваем к API_BASE_URL
// - если абсолютный — разрешаем только https и только тот же origin, что у API
function buildUrl(input) {
  if (!isAbsolute(input)) {
    return joinBase(API_BASE_URL, input);
  }
  const u = new URL(input);
  if (u.protocol !== "https:") {
    throw new Error(`Запрещён протокол: ${u.protocol}. Разрешён только https.`);
  }
  if (u.origin !== API_ORIGIN) {
    throw new Error(`Запрещён внешний origin: ${u.origin}. Разрешён только ${API_ORIGIN}.`);
  }
  return u.toString();
}

// Обёртка над fetch с:
// - credentials: 'include' (куки)
// - таймаутом (20s) через AbortController
// - базовыми заголовками
export async function authFetch(input, init = {}) {
  const url = buildUrl(typeof input === "string" ? input : String(input?.url || ""));
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), init.timeoutMs ?? 60000);

  const headers = new Headers(init.headers || {});
  if (!headers.has("Accept")) headers.set("Accept", "application/json");
  const isFormData =
    typeof FormData !== "undefined" && init.body instanceof FormData;
  // Если есть body и нет Content-Type — ставим JSON, кроме FormData.
  if (init.body && !isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  try {
    const res = await fetch(url, {
      ...init,
      headers,
      credentials: init.credentials ?? "include",
      signal: controller.signal,
    });
    // === Глобальная блокировка DEMO: ловим 403 и шлём событие для модалки ===
    try {
      if (res && res.status === 403) {
        const cloned = res.clone();
        const data = await cloned.json().catch(() => null);
        const detail = (data && (data.detail || data)) || null;
        const code = detail && (detail.code || detail?.error || detail?.message);
        if (code === "DEMO_ADD_BLOCKED") {
          const action = detail.action || null;
          if (typeof window !== "undefined" && window.dispatchEvent) {
            window.dispatchEvent(
              new CustomEvent("demo:block", {
                detail: { action, url, when: Date.now() },
              })
            );
          }
        }
      }
    } catch (_e) {}
    return res; // парсинг (json/text) — на стороне вызывающего
  } finally {
    clearTimeout(timeout);
  }
}
